<template>
    <div class="login_form loading formHolder" id="login_form">
        <form class="login" novalidate @submit.prevent="login">
            <h1 class="stepTitle">{{settings.value?.local?.title}}</h1>
            <p class="stepText">{{settings.value?.local?.subTitle}}</p>

            <div class="radioHolder">
                <div class="grid">
                    <label>
                        <input type="radio" class="email active" name="method" value="email" checked v-model="loginForm.method">
                        <div>{{settings.value?.local?.byEmail}}</div>
                    </label>

                    <label>
                        <input type="radio" class="phone active" name="method" value="phone" disabled v-model="loginForm.method">
                        <div>{{settings.value?.local?.byPhone}}</div>
                    </label>
                </div>
            </div>

            <div id="email_method">
                <p class="stepSubText">{{settings.value?.local?.instructionEmail}}</p>

                <div class="inputHolder">
                    <label for="email">E-mail</label>
                    <input
                        type="email"
                        required
                        name="email"
                        id="email"
                        :placeholder="settings.value?.local?.yourEmail"
                        v-model="loginForm.email"
                        :class="{'error': validateErrors.value && validateErrors.value.email}"
                    >
                    <span v-if="isEmailValid" class="validation-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none">
                            <path d="M17 1L6 12L1 7" stroke="#4FBC35" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span v-if="validateErrors.value && validateErrors.value.email" class="error">
                          {{ validateErrors.value.email }}
                    </span>
                </div>

            </div>
            <div class="controls">
                <button type="submit" class="mainButton" :disabled="loginForm.method === 'email' && (!loginForm.email || !isEmailValid)">
                    {{settings.value?.local?.getLink}}
                </button>
            </div>

            <div class="checkboxHolder agree">
                <input type="checkbox" id="terms_agree" name="terms_agree" required v-model="loginForm.terms_agree">
                <div class="label">
                    <label for="terms_agree"><span class="checkbox"></span><span></span></label>
                    <div><span>{{settings.value?.local?.termsAgree}} <a :href="settings.value?.termsUrl">{{settings.value?.local?.terms}}</a></span></div>
                </div>
                <span v-if="validateErrors.value && validateErrors.value.terms_agree" class="error">
                    {{ validateErrors.value.terms_agree }}
                </span>
            </div>

            <div class="privacy">
                This site is protected by reCAPTCHA and the Google
                <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </div>
        </form>
        <div class="infoStep email" v-if="infoStepEmail">
            <div class="stepTitle">{{settings.value?.local?.checkEmail}}</div>
            <div class="stepText">{{settings.value?.local?.checkEmailSub}} <span>{{loginForm.email}}</span></div>
            <button @click.prevent="infoStepEmail = false" class="changeValue">{{settings.value?.local?.changeEmail}}</button>

            <div class="timer smallText">{{settings.value?.local?.resendEmail}} {{timerText.value}}</div>

            <div class="controls">
                <button class="mainButton" :disabled="timer && timer.value" @click.prevent="login">{{settings.value?.local?.resendEmailButton}}</button>
            </div>

        </div>
    </div>
</template>

<script setup>
import '@/assets/css/form.css';
import { useReCaptcha } from 'vue-recaptcha-v3'
import {ajax} from "@/assets/js/Functions"
import {computed, onMounted, reactive, ref} from "vue";
const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()
const settings = reactive({});
const validateErrors = reactive({});

let infoStepEmail = ref(false)
let timer = reactive({})
let timerText = reactive({ value: '0:00' })

const loginForm = reactive({
    method: 'email',
    email: null,
    phone: null,
    terms_agree: null
});

const recaptcha = async () => {
    await recaptchaLoaded()
    return await executeRecaptcha('login')
}

const isEmailValid = computed(() => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(loginForm.email);
});

const login = () => {
    recaptcha().then((captchaToken)=>{
        switch (loginForm.method){
            case 'email':
                ajax({
                    action: 'send_confirm_email',
                    email: loginForm.email,
                    phone: loginForm.phone,
                    terms_agree: loginForm.terms_agree ? 1 : 0,
                    recaptcha_response: captchaToken
                }, (response) => {
                    process(response)
                })
                break;

            case 'phone':
                alert('This method is not used')
                break;
        }

    })
}

const process = (data) => {
    startTimer()
    if(!data) return

    validateErrors.value = {}

    if( data.status && data.status === 'error' ){
        if( data.fields ) validateErrors.value = data.fields
        if( data.text ) alert( data.text )
        return
    }
    startTimer()
    infoStepEmail = true
}

const startTimer = () => {
    if (timer.value) clearInterval(timer.value);
    let remainingTime = 120;

    const updateTimerText = () => {
        const minutes = Math.floor(remainingTime / 60);
        const seconds = remainingTime % 60;
        timerText.value = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    timer.value = setInterval(() => {

        remainingTime -= 1
        updateTimerText()
        if (remainingTime <= 0) {
            clearInterval(timer.value)
            localStorage.removeItem('cabinetTimer')
            timer.value = 0
            return
        }
        localStorage.setItem('cabinetTimer', remainingTime.toString())
    }, 1000);
}

onMounted(async () => {
    ajax({
        action: 'cabinet_login_settings'
    }, (response) => {
        settings.value = response
    })
});

</script>

<style>
.login_form.formHolder {
    padding: 0;
    box-shadow: none;
    background: transparent;
}
.inputHolder{
    position: relative;
}
.checkboxHolder{
    padding-bottom: 0;
}
.changeValue{
    color: #007EFF;
    text-align: center;
    font-size: 13px;
    font-weight: 500;
    margin: 40px 0;
    border: 0;
    padding: 0;
}
.infoStep .stepText {
    display: block;
    margin-bottom: 0;
}
.infoStep .stepText span{
    color: var(--color-primary);
}
.grecaptcha-badge{
    display: none!important;
}
.validation-icon {
    position: absolute;
    top: calc(50% + 5px);
    right: 20px;
    transform: translateY(-50%);
    font-size: 16px;
}
.validation-icon svg{
    width: 24px;
    height: 24px;
}
@media all and (max-width: 768px){
    .formHolder {
        padding: 0 10px;
    }
    form {
        padding: 34px 20px;
    }
    .stepTitle {
        margin: 0 0 24px;
        font-size: 20px;
    }
    .stepText {
        margin: 0 0 40px;
    }
}
</style>